import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const PersonSVG = ({ size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <g clipPath="url(#clip0_2393_113693)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.84521 15.943V16.949C5.84535 17.2186 5.89862 17.4856 6.00199 17.7347C6.10536 17.9837 6.2568 18.2099 6.44765 18.4004C6.6385 18.5909 6.86502 18.7419 7.11426 18.8448C7.3635 18.9476 7.63057 19.0004 7.90021 19H16.1002C16.3699 19.0004 16.6369 18.9476 16.8862 18.8448C17.1354 18.7419 17.3619 18.5909 17.5528 18.4004C17.7436 18.2099 17.8951 17.9837 17.9984 17.7347C18.1018 17.4856 18.1551 17.2186 18.1552 16.949V15.943C18.1366 15.5765 18.0181 15.2221 17.8126 14.918C17.6071 14.614 17.3223 14.3719 16.9892 14.218C13.7875 12.932 10.2129 12.932 7.01121 14.218C6.67809 14.3719 6.39338 14.614 6.18787 14.918C5.98236 15.2221 5.86387 15.5765 5.84521 15.943ZM10.0999 5.57589C10.6624 5.20021 11.3238 4.9998 12.0002 5C12.4493 5 12.894 5.08847 13.3088 5.26035C13.7237 5.43224 14.1007 5.68417 14.4182 6.00176C14.7357 6.31935 14.9875 6.69637 15.1592 7.1113C15.331 7.52623 15.4193 7.97093 15.4192 8.42C15.4192 9.09646 15.2186 9.75772 14.8428 10.3202C14.4669 10.8826 13.9327 11.3209 13.3078 11.5798C12.6828 11.8386 11.9951 11.9063 11.3316 11.7742C10.6682 11.6422 10.0588 11.3163 9.58056 10.838C9.1023 10.3596 8.77666 9.75008 8.64481 9.0866C8.51296 8.42312 8.58083 7.73544 8.83983 7.11053C9.09884 6.48562 9.53734 5.95156 10.0999 5.57589ZM13.2092 14.3503L14.8473 15.866C15.0509 16.0525 15.0509 16.3447 14.8473 16.5312L13.2092 18.0469C12.9999 18.2421 12.6472 18.2528 12.4236 18.0664C12.1999 17.8829 12.1899 17.5761 12.4013 17.3808L13.0776 16.7547H9.55646C9.24928 16.7547 9 16.4702 9 16.2021C9 15.9341 9.24928 15.7755 9.62276 15.7755H9.62296H13.2205L12.4013 15.0165C12.1899 14.8223 12.2064 14.5204 12.4236 14.3309C12.7115 14.0798 13.1013 14.2494 13.2092 14.3503Z"
          fill="#BCBEC2"
        />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      <defs>
        <clipPath id="clip0_2393_113693">
          <rect width="14" height="14" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PersonSVG;
